<template>
  <div class="loading-container">
    <div class="loading-content">
      <div class="logo-pulse">
        <img 
          :src="require('@/assets/logos/PTLogo-SVG-NoText-Cropped.svg')"
          alt="Principal Task Logo"
          class="loading-logo"
        />
      </div>
      <h2 class="loading-title">Principal Task</h2>
      <p class="loading-subtitle">Built for productive people (and those who want to be)</p>
      <div class="loading-dots">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>
</template>

<script>
// 20260125 -- Copilot (Claude Sonnet 4.5) -- Modernized loading screen with animated logo
// Works inline within AppLayout or standalone
// 
// TODO: Loading component currently replaces entire layout when used
// Pages like Tasks.vue render <Loading> outside <AppLayout>, causing jarring transition
// Should refactor pages to use Loading inside AppLayout content slot for smooth transitions
// Affects: Tasks.vue, TaskDetail.vue, UserStats.vue, Profile.vue, etc.
export default {
  name: 'Loading',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
}

.loading-content {
  text-align: center;
  max-width: 400px;
}

/* Logo pulse animation */
.logo-pulse {
  width: 160px;
  height: 160px;
  margin: 0 auto 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

.loading-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(120, 203, 91, 0.3));
}

.loading-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e3a5f;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.5px;
}

.loading-subtitle {
  font-size: 1rem;
  color: #6c757d;
  margin: 0 0 2rem 0;
  font-weight: 400;
}

/* Animated dots */
.loading-dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background-color: #78CB5B;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite;
}

.loading-dots span:nth-child(1) {
  animation-delay: 0s;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  40% {
    transform: translateY(-10px);
    opacity: 1;
  }
}
</style>